// Values mirror the OverrideReason GraphQL enum (api DRI-1192/DRI-2873).
export const OVERRIDE_REASONS = [
	{ value: 'GUEST_ASSISTANCE', label: 'Guest assistance' },
	{ value: 'NO_RESERVATION', label: 'No reservation' },
	{ value: 'STAFF_ACCESS', label: 'Staff access' },
	{ value: 'TECHNICAL_ERROR', label: 'Technical issue' },
	{ value: 'MAINTENANCE', label: 'Maintenance' },
	{ value: 'BAY_CHANGE', label: 'Bay change' },
	{ value: 'OTHER', label: 'Other' },
];
